import {
  Box,
  Card,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getHistoryPaymentBrands } from "../../services/payment";
import ListHead from "../table/ListHead";
import Scrollbar from "../table/Scrollbar";
import { applySortFilter } from "../../utils/tableFunctions";
import { StyledTableRow } from "../TableRow";
import CircularLoader from "../circularLoader";
import CommonDialog from "../CustomDialog";
import PaymentBrandDetails from "../Admin-PaymentBrand/Dialogs/PaymentBrandDetails";
import Label from "../Label";

const TABLE_HEAD = [
  { id: "name", label: "Brand Name" },
  { id: "payment_method", label: "Payment Methods" },
  { id: "action", label: "Action" },
  { id: "is_approved", label: "Approved" },
];

const PaymentHostHistory = () => {
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("");
  const [brandHistory, setbrandHistory] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    page_size: 50,
  });

  const queryPage = (queryParams) => {
    setLoaded(false);
    getHistoryPaymentBrands({
      setResponse: renderData,
      setLoaded: setLoaded,
      filter: queryParams,
    });
    setPagination({
      page: queryParams.page || 1,
      page_size: queryParams.page_size || 50,
    });
  };

  const CustomTableCell = ({ align, field, id }) => {
    return (
      <TableCell
        align={align}
        onClick={() => {
          // window.open(`/3/app/details/payment-brand-history/${id}`, "_blank");
          setItemId(id);
        }}
      >
        {field}
      </TableCell>
    );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = (brandHistory.results || []).map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    queryPage({
      page: newPage + 1,
      page_size: pagination.page_size,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage({
      page: 1,
      page_size: parseInt(event.target.value, 10),
    });
  };

  const emptyRows =
    pagination.page > 0 ? Math.max(0, pagination.page * pagination.page_size - (brandHistory?.count || 0)) : 0;

  const filteredList = applySortFilter(
    brandHistory.results || [],
    order,
    orderBy
  );

  const isItemNotFound = (brandHistory.results || []).length === 0;

  const renderData = data => {
    if (!data || !data.results) return;
    const newData = data.results.map(item => ({
      ...item,
      payment_method: item.payment_method
        ?.map((method) => method.name)
        .join(", ")
    }))
    setbrandHistory({ count: data.count, results: newData });
  }

  useEffect(() => {
    queryPage(pagination);
  }, []);

  return (
    <Box>
      {loaded ?
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={brandHistory?.count || 0}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  checkbox={false}
                />

                <TableBody>
                  {filteredList
                    .map((row) => {
                      const { id, name, payment_method, action, is_approved } = row;
                      const isItemSelected = selected.indexOf(id) !== -1;

                      return (
                        <StyledTableRow
                          hover
                          key={id}
                          aria-checked={isItemSelected}
                        >
                          <CustomTableCell
                            field={name}
                            id={id}
                          />
                          <CustomTableCell
                            field={payment_method}
                            id={id}
                          />
                          <CustomTableCell
                            field={action}
                            id={id}
                          />
                          <TableCell align="left" onClick={() => setItemId(id)}>
                            <Label variant="ghost" color={is_approved ? "success" : "error"}>
                              {is_approved ? "YES" : "NO"}
                            </Label>
                          </TableCell>
                        </StyledTableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: 53 * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isItemNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            No payment brand history found.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={brandHistory?.count || 0}
            rowsPerPage={pagination.page_size}
            page={pagination.page - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        :
        <CircularLoader />
      }

      {itemId && (
        <CommonDialog
          title={"Payment Brand History Details"}
          onClose={() => setItemId(null)}
        >
          <PaymentBrandDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Box>
  );
};

export default PaymentHostHistory;
